import { Array, Boolean, Dictionary, Literal, Number, Partial, Record, String, Union, Unknown } from "runtypes";
import { Course } from "./course";
import { Name, Person } from "./person";
import { StaffProfile, StudentProfile } from "./profile";
import { Category, Role, StaffRoles } from "./role";
import { Semester } from "./semesters";
export const StaffMember = Record({
  name: String,
  netID: String,
  email: String,
  role: Role
}).And(
  Partial({
    profile: StaffProfile,
    language: String
  })
);
export const FullResponse = Record({
  semester: Semester,
  course: Course,
  timestamp: Number
}).And(
  Partial({
    staff: Array(StaffMember),
    you: Person,
    category: Category,
    isStaff: Boolean,
    title: String,
    role: Role,
    staffRole: StaffRoles,
    roles: Array(Role),
    extra: Dictionary(Unknown),
    profile: Union(StaffProfile, StudentProfile),
    language: Union(Literal("java"), Literal("kotlin"), Literal("both")),
    mentor: String,
    mentees: Array(String),
    impersonating: Boolean,
    actualYou: Person,
    actualRole: Role,
    token: String,
    name: Name
  })
);
export const ProfileResponse = Record({
  person: Person,
  category: Category,
  isStaff: Boolean,
  title: String,
  roles: Array(Role)
}).And(
  Partial({
    role: Role,
    profile: Union(StaffProfile, StudentProfile),
    language: Union(Literal("java"), Literal("kotlin"), Literal("both"))
  })
);
//# sourceMappingURL=api.js.map
